import React from "react";

export enum ExpressionRenderType {
    FULL = "full",
    COMPACT = "compact",
    TEXT = "text",
}

export interface CompactColor {
    missing?: string;
    expression?: string;
    variable?: string;
    value?: string;
    result?: string;
    bracket?: {
        error?: string;
        warning?: string;
        default?: string;
    };
}

export interface IExpressionContext {
    renderType: ExpressionRenderType;
    missing: {
        default: string;
        subexpression: string;
        variable: string;
        value: string;
    };
    color?: CompactColor;
    hideValidation?: boolean;
}

export const expressionSettings: { [key: string]: IExpressionContext } = {
    [ExpressionRenderType.FULL]: {
        renderType: ExpressionRenderType.FULL,
        missing: {
            default: "Edit Expression",
            subexpression: "Pick Expression",
            variable: "Enter Variable",
            value: "Enter Value",
        },
    },
    [ExpressionRenderType.COMPACT]: {
        renderType: ExpressionRenderType.COMPACT,
        missing: {
            default: "[Edit Expression]",
            subexpression: "[Pick Expression]",
            variable: "[Enter Variable]",
            value: "[Enter Value]",
        },
    },
    [ExpressionRenderType.TEXT]: {
        renderType: ExpressionRenderType.TEXT,
        missing: {
            default: "[Edit Expression]",
            subexpression: "[Pick Expression]",
            variable: "[Enter Variable]",
            value: "[Enter Value]",
        },
    },
};

export const ExpressionReactContext = React.createContext<IExpressionContext>(
    expressionSettings[ExpressionRenderType.FULL]
);
